/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Type of expansion set data being modified.
 */
export var ExpansionSetType;
(function (ExpansionSetType) {
    ExpansionSetType["WHITELIST"] = "whitelist";
    ExpansionSetType["BLACKLIST"] = "blacklist";
})(ExpansionSetType || (ExpansionSetType = {}));
